import { SubscriptionProduct } from '../../../models/subscription-product';
import { ITransaction } from '../../../models/transaction';
import { Product as IProduct } from '../../../models/product';
import { Price } from '../../../models/price';

export namespace Product.Actions {
  export class GetPrices {
    public static readonly type = '[Prices] Get Prices';
    constructor(public productId: string) {}
  }
  export class SetPrices {
    public static readonly type = '[Prices] Set Prices';
    constructor(public prices: Price[]) {}
  }

  export class GetSelectedPrice {
    public static readonly type = '[Prices] Get Get Selected Price]';
    constructor(public priceId: string) {}
  }

  // export class SetPrimaryTransaction {
  //   public static readonly type = '[Products]Sey Primary Transaction]';
  //   constructor(public transaction: Price) {}
  // }

  export class InsertPrice {
    public static readonly type = '[Prices] Insert Price]';
    constructor(public price: Price) {}
  }

  export class DeletePrice {
    public static readonly type = '[Prices] Delete Price]';
    constructor(public product: IProduct, public price: Price) {}
  }

  // export class GetBalances {
  //   public static readonly type = '[Products]Get Balance Transaction]';
  //   constructor(
  //     public primaryTransaction: ITransaction,
  //     public splitTransactions: ITransaction[]
  //   ) {}
  // }

  // export class GetBalances {
  //   public static readonly type = '[Products]Get Balances]';
  //   constructor(primaryTransaction: ITransaction, splitTransactions: ITransaction[]) {}
  // }

  export class EditPrice {
    public static readonly type = '[Products] Edit Single Price]';
    constructor(public price: Price) {}
  }

  // export class GetCampaignOrders {
  //   public static readonly type = '[Products]Get Campaign Orders';
  //   constructor(public organizationId: string, public campaignId: string) {}
  // }

  // export class DeleteCampaignOrder {
  //   public static readonly type = '[Products]Delete Single Campaign Order]';
  //   constructor(public order: ITransaction) {}
  // }
}
